import React, { useState } from "react";
import floralPattern from "../../assets/images/dogs/Floral Pattern - Dark.png";
import Lottie from "lottie-react";

// Replace with your real dog gifs
import dog1 from "../../assets/images/dogs/Alex and Rosie.gif";
import dog2 from "../../assets/images/dogs/Melanie Roxy Chloe and Bella.gif";
import dog3 from "../../assets/images/dogs/Devon and Willo.gif";
import dog4 from "../../assets/images/dogs/Joanne and Sully.gif";
import dog5 from "../../assets/images/dogs/Sharon and Abby.gif";
import dog6 from "../../assets/images/dogs/Swathi and Felix.gif";
import dog7 from "../../assets/images/dogs/Joanna Ellie and Zoe.gif";

import clickAnim from "../../assets/images/dogs/Handtap.json";




const dogs = [
    {
        id: 1,
        front: dog1,
        caption: `"Every time we go on a hike she runs along in front of me, but stops to turn around every so often to make sure I'm still following."`,
        className: "top-[0rem] left-[10rem] w-[450px] h-[560px] z-10",
        author: "Alex and Rosie"
    },
    {
        id: 2,
        front: dog2,
        caption: `"My three dogs, “The Girls” and I are a team. They are like little love bugs all day, every day. When my husband had major back surgery a year ago, all three dogs took turns sitting with him all day while he recovered. They are perceptive and attuned to us."`,
        className: "top-[600px] left-[1rem] w-[600px] h-[450px] z-20",
        author: 'Melanie, Roxy, Chloe and Bella'
    },
    {
        id: 3,
        front: dog3,
        caption: `"No matter where we are or what we're doing, she's always watching me and paying attention to where I am. Sometimes it feels like she loves everyone, but I'm the only one she's always keeping tabs on."`,
        className: "top-[400px] left-[650px] w-[450px] h-[550px] z-30",
        author: `Devon and Willo`
    },
    {
        id: 4,
        front: dog4,
        caption: `"When Sully was a puppy and I would leave for work, he would cry and throw himself against the door. No one else in the house was able to console him and he would pout for about a half hour. When I would come home he would jump up and hug me."`,
        className: "top-[1100px] left-[210px] w-[400px] h-[500px] z-20",
        author: 'Joanne and Sully'
    },
    {
        id: 5,
        front: dog5,
        caption: `"Abby is usually attached to me, I can't leave the room without her following closely behind. I can tell when she needs me and she knows when I need her. In dog training they say we should always know where our dogs nose is... that leads the dog... I think Abby always knows where my nose is as well."`,
        className: "top-[1000px] left-[650px] w-[490px] h-[400px] z-10",
        author: 'Sharon and Abby'
    },
    {
        id: 6,
        front: dog6,
        caption: `"Felix comes and sits on my lap and gives me kisses when I am sad. He loves hugs and looking into his eyes is always therapeutic."`,
        className: "top-[1450px] left-[650px] w-[460px] h-[560px] z-30",
        author: 'Swathi and Felix'
    },
    {
        id: 7,
        front: dog7,
        caption: `"I usually swim laps, but was tired and decided to float for a minute. Ellie was watching and immediately barked, alerted my husband and led him to the pool. She stopped barking when I stood up and she could see that I was not drowning. She always stands guard while I swim now."`,
        className: "top-[1650px] left-[2rem] w-[600px] h-[500px] z-10",
        author: 'Joanna, Ellie Bean and Zoe Bechamel'
    },
];

// export default function DogGifGallery() {
//     const [flipped, setFlipped] = useState(null);

//     return (
//         <div
//             className="relative min-h-[2700px] w-full overflow-hidden bg-repeat bg-center "
//             style={{ backgroundImage: `url('${floralPattern}')` }}
//         >
//             {/* Dark overlay */}
//             <div className="absolute inset-0 bg-black opacity-60 z-0" />

//             {/* Header */}
//             <div className="relative z-10 text-center text-white px-6 py-56">
//                 <h2 className="text-xl md:text-2xl font-semibold mb-2">
//                     We asked our readers about a time they knew their dog loved them.
//                 </h2>
//                 <p className="text-sm md:text-base opacity-90">
//                     Click the photos to read their stories
//                 </p>
//             </div>

//             {/* 📌 Collage Layout (Only on lg and up) */}
//             <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 max-w-[1200px] w-full h-[2700px] z-10">
//                 {dogs.map((dog) => (
//                     <div
//                         key={dog.id}
//                         className={`absolute cursor-pointer perspective ${dog.className}`}
//                         onClick={() =>
//                             setFlipped((prev) => (prev === dog.id ? null : dog.id))
//                         }
//                     >
//                         <div
//                             className={`relative w-full h-full transition-transform duration-700 transform-style-preserve-3d ${flipped === dog.id ? "rotate-y-180" : ""
//                                 }`}
//                         >
//                             {/* Front */}
//                             <div className="absolute inset-0 backface-hidden overflow-hidden">
//                                 <img
//                                     src={dog.front}
//                                     alt="Dog GIF"
//                                     className="w-full h-full"
//                                 />
//                             </div>

//                             {/* Back */}
//                             <div className="absolute inset-0 backface-hidden rotate-y-180 bg-[#f8f3ec] border-[12px] border-yellow-800 shadow-xl rounded-sm flex flex-col items-center justify-center p-6 text-center text-gray-800 ">
//                                 <p className="leading-relaxed font-bold text-sm sm:text-base">{dog.caption}</p>
//                                 <p className="leading-relaxed text-sm mt-4">{dog.author}</p>

//                             </div>
//                         </div>
//                     </div>
//                 ))}
//             </div>

//             {/* 📱 Mobile Layout (Stacked vertically) */}
//             <div className="block lg:hidden relative z-10 px-4 flex flex-col gap-8 pb-20">
//                 {dogs.map((dog) => (
//                     <div
//                         key={dog.id}
//                         className="w-full cursor-pointer perspective max-w-md mx-auto"
//                         onClick={() =>
//                             setFlipped((prev) => (prev === dog.id ? null : dog.id))
//                         }
//                     >
//                         <div
//                             className={`relative w-full h-[500px] transition-transform duration-700 transform-style-preserve-3d ${flipped === dog.id ? "rotate-y-180" : ""
//                                 }`}
//                         >
//                             {/* Front */}
//                             <div className="absolute inset-0 backface-hidden overflow-hidden  ">
//                                 <img
//                                     src={dog.front}
//                                     alt="Dog GIF"
//                                     className="w-full h-full "
//                                 />
//                             </div>

//                             {/* Back */}
//                             <div className="absolute inset-0 backface-hidden rotate-y-180 bg-[#f8f3ec] border-[10px] border-yellow-800 shadow-xl rounded-md flex items-center justify-center p-6 text-center text-gray-800 text-sm sm:text-base">
//                                 <p className="italic leading-relaxed">{dog.caption}</p>
//                             </div>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// }


export default function DogGifGallery() {
    const [flipped, setFlipped] = useState(null);

    const toggleFlip = (id) => setFlipped((prev) => (prev === id ? null : id));

    return (
        <div
            className="relative min-h-[2850px] w-full overflow-hidden bg-repeat bg-center"
            style={{ backgroundImage: `url('${floralPattern}')` }}
        >
            {/* Dark overlay */}
            <div className="absolute inset-0 bg-black opacity-60 z-0" />

            {/* Header */}
            <div className="relative z-10 text-center text-white px-6 py-56">
                <h2 className="text-xl md:text-2xl font-semibold mb-2">
                    We asked our readers about a time they knew their dog loved them.
                </h2>
                <p className="text-sm md:text-base opacity-90">
                    Click the photos to read their stories
                </p>
            </div>

            {/* Desktop collage */}
            <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 max-w-[1200px] w-full h-[2700px] z-10">
                {dogs.map((dog) => (
                    <div
                        key={dog.id}
                        className={`absolute cursor-pointer perspective ${dog.className}`}
                        onClick={() => toggleFlip(dog.id)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") toggleFlip(dog.id);
                        }}
                        aria-label={`Open story: ${dog.author}`}
                    >
                        <div
                            className={`relative w-full h-full transition-transform duration-700 transform-style-preserve-3d ${flipped === dog.id ? "rotate-y-180" : ""
                                }`}
                        >
                            {/* Front */}
                            <div className="absolute inset-0 backface-hidden overflow-hidden">
                                <img src={dog.front} alt={dog.author} className="w-full h-full" />

                                {/* click icon (top-right) */}
                                {dog.id === 1 && (
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleFlip(dog.id);
                                        }}
                                        className="absolute top-12 right-12 z-30 flex items-center gap-2 px-3 py-2 rounded-full  "
                                        aria-label="Click to read story"
                                    >
                                        <div className="w-7 h-7">
                                            <Lottie animationData={clickAnim} loop autoplay />
                                        </div>
                                        <span className="text-xs font-semibold text-white whitespace-nowrap">
                                            Click me
                                        </span>
                                    </button>
                                )}

                            </div>

                            {/* Back */}
                            <div className="absolute inset-0 backface-hidden rotate-y-180 bg-[#f8f3ec] border-[12px] border-yellow-800 shadow-xl rounded-sm flex flex-col items-center justify-center p-6 text-center text-gray-800">
                                <p className="leading-relaxed font-bold text-sm sm:text-base">{dog.caption}</p>
                                <p className="leading-relaxed text-sm mt-4">{dog.author}</p>


                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Mobile stacked */}
            <div className="block lg:hidden relative z-10 px-4 flex flex-col gap-8 pb-40">
                {dogs.map((dog) => (
                    <div
                        key={dog.id}
                        className="w-full cursor-pointer perspective max-w-md mx-auto"
                        onClick={() => toggleFlip(dog.id)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") toggleFlip(dog.id);
                        }}
                        aria-label={`Open story: ${dog.author}`}
                    >
                        <div className={`relative w-full h-[500px] transition-transform duration-700 transform-style-preserve-3d ${flipped === dog.id ? "rotate-y-180" : ""}`}>
                            {/* Front */}
                            <div className="absolute inset-0 backface-hidden overflow-hidden">
                                <img src={dog.front} alt={dog.author} className="w-full h-full" />

                                {dog.id === 1 && (
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleFlip(dog.id);
                                        }}
                                        className="absolute top-12 right-12 z-30 w-10 h-10 rounded-full bg-white/90 flex items-center justify-center shadow"
                                        aria-label={`Open story for ${dog.author}`}
                                    >
                                        <div className="w-7 h-7">
                                            <Lottie animationData={clickAnim} loop autoplay style={{ width: "100%", height: "100%" }} />
                                        </div>
                                    </button>
                                )}
                            </div>

                            {/* Back */}
                            <div className="absolute inset-0 backface-hidden rotate-y-180 bg-[#f8f3ec] border-[10px] border-yellow-800 shadow-xl rounded-md flex items-center justify-center p-6 text-center text-gray-800 text-sm sm:text-base">
                                <p className="italic leading-relaxed">{dog.caption}</p>


                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}